import { Component, EventEmitter, Output, OnInit, Input } from '@angular/core';
import { DefaultCompanyRepository } from '@src/core/repositories/company/default-company.repository';
import { DefaultCompanyRequest } from '@src/core/domain/company/defaultCompany.model';
import { CompanyDataShare } from '@src/core/usecases/data-share/company-data-share.service';
import { ModalStateService } from '@src/shared/services/authV3/modal-state.service';
import { setCompanyIndexUsecases } from '@src/core/usecases/company/set-companyIndex.usecase';
import { CompanyRequest } from '@src/core/domain/company/companyType.model';
import { MsalService } from '@azure/msal-angular';
import { formatStringName, getTextWidth } from '@src/shared/util-common';

interface dataGenerica {
  id: number;
  titulo: string;
  descricao: string;
}

@Component({
  selector: 'app-popover',
  templateUrl: './popover.component.html',
  styleUrls: ['./popover.component.scss']
})
export class PopoverComponent implements OnInit {
  @Output() closePopover = new EventEmitter<void>();
  @Input() flagShowCheckbox: boolean;

  visible: boolean = false;
  selectedCompany: number;
  selectedCompanyIndex: number;
  selectedComapnyCpfCnpj: string;
  selectedCheckBox: boolean = false;
  data: dataGenerica[] = [];
  showLoader: boolean = false;
  contador = 0;
  constructor(
    private modalStateService: ModalStateService,
    private defaultCompany: DefaultCompanyRepository,
    private companyDataShare: CompanyDataShare,
    private setCompany: setCompanyIndexUsecases,
    private authService: MsalService
  ) { }

  ngOnInit(): void {
    this.modalStateService.modalVisibility$.subscribe(visible => {
      this.visible = visible;
    });

    this.modalStateService.modalData$.subscribe(clientes => {
      if (clientes) {

        const nomes = clientes.map(item => item.nome);
        const font = '700 16px Roboto';
        const suffix = ' (...)';
        const textWidths = nomes.map(name => getTextWidth(name, font));
        const layoutMaxWidth = 330;
        const maxNameWidth = Math.min(Math.max(...textWidths), layoutMaxWidth - getTextWidth(suffix, font));
        this.data = clientes.map(item => ({
          id: item.id,
          titulo: formatStringName(item.nome, maxNameWidth, font),
          descricao: item.numeroDocumento
        }));
      }
    });
  }

  get botaoHabilitado(): boolean {
    if (!this.flagShowCheckbox)
      return this.selectedCheckBox || this.contador > 1;
    else
      return this.contador > 1;
  }

  onCompanySelected(event: { id: number; index: string }) {
    this.contador = this.contador + 1;
    this.selectedCompany = event.id;
    this.selectedComapnyCpfCnpj = event.index;
    console.log('---------------<OnCompanySelected>-------------')
    const empresas = this.modalStateService.getEmpresas();
    console.log(empresas)
    if (empresas) {
      const empresaEncontrada = empresas.find(e => e.cpfCnpj === event.index);
      if (empresaEncontrada) {
        this.selectedCompanyIndex = empresaEncontrada.indice;
      } else {
        this.selectedCompanyIndex = 0; // fallback
      }
    }else{
      this.selectedCompanyIndex = 0;
    }
  }

  confirmSelection() {
    if (!this.selectedCompany && !this.selectedCheckBox) return;
    this.showLoader = true;
    const empresas = this.modalStateService.getEmpresas();
    const empresaEncontrada = empresas.find(e => e.cpfCnpj === this.selectedComapnyCpfCnpj);
    if (empresaEncontrada) {
      this.selectedCompanyIndex = empresaEncontrada.indice;
    } else {
      this.selectedCompanyIndex = 0;
    }
    const params: DefaultCompanyRequest = {
      idCliente: this.selectedCompany,
      perguntarClientePadrao: this.selectedCheckBox
    };
    this.defaultCompany.setDefaultCompany(params).subscribe(
      () => this.requestComplete(),
      error => this.handleError(error)
    );
  }

  private requestComplete() {
    this.companyDataShare.setSelect(false);
    sessionStorage.setItem(
      'defalutCompanyId',
      this.selectedCompany.toString()
    );
    sessionStorage.setItem(
      'showAskCompanyDefault',
      JSON.stringify(this.selectedCheckBox)
    );
    sessionStorage.setItem(
      'showAskCompanyDefaultTwo',
      JSON.stringify(true)
    );
    this.reloadSession(this.selectedCompanyIndex);
  }

  private handleError(error: any) {
    let errorMessage = 'Erro desconhecido';
    if (error && error.error instanceof ErrorEvent) {
      errorMessage = `Erro do lado do cliente: ${error.error.message}`;
    } else if (error && error.status) {
      errorMessage = `Erro HTTP ${error.status}: ${error.message || 'Sem mensagem'}`;
    }
    console.error(errorMessage);
    this.authService.logout();
  }

  ngOnDestroy() {
    this.selectedCheckBox = false;
    this.selectedCompany = null;
    document.body.style.overflow = '';
  }

  close() {
    this.selectedCheckBox = false;
    this.selectedCompany = null;
    document.body.style.overflow = '';
    this.modalStateService.closeModal();
  }

  public reloadSession = (indice): void => {
    const param: CompanyRequest = {
      index: indice,
      persistir: this.selectedCheckBox,
    };
    this.setCompany
      .execute(param)
      .subscribe(
        this.setCompanySuccess,
        this.setCompanyError,
        this.setCompanyComplete
      );
  }
  private setCompanySuccess = (res) => {
    if (res && res.data) {
      sessionStorage.setItem('x-ibpj-session', res.data.token_sessao);
    }
  }
  private setCompanyError = (err) => {
    console.log('Company Set Error:', err);
  }

  private setCompanyComplete() {
    location.reload();
  }

  errorTerm = (err) => {
    console.log('error', err);
  }
}